import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Button, NumberBox, Popup, ScrollView, TextBox } from "devextreme-react";
import axios from "axios";
import { alert } from "devextreme/ui/dialog";
import FormField from "../../../../../../dynamicFormBuilder/FormField";
import { TotalWeightLayout } from "./Layout";
import Fields from "../../../../../../dynamicFormBuilder/Fields";

function UpdateSubDetailTotalWeight(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const [records, setRecords] = React.useState(0);
    const [formFields, setformFields] = React.useState({
        NetWeight: props.showPopup.subDetail?.netweight || 0,
        GrossWeight: props.showPopup.subDetail?.grossweight || 0,
        UpdatedNetWeight: null,
        UpdatedGrossWeight: null
    });
    const handleFieldChange = (name, value) => {
        setformFields((prevFormFields) => ({
            ...prevFormFields,
            [name]: value,
        }));
    }
    const UpdateTotalWeight = async () => {
        const payload = {
            Netweight: formFields.UpdatedNetWeight,
            Grossweight: formFields.UpdatedGrossWeight,
            Rowid: props.showPopup.subDetail?.rowid,
            RTransactiondetail: props.detailRowId,
            RSublot: props.showPopup.subDetail?.rSublot,
        };
        try {
            props.setLoadPanelVisible(true);
            const res = await axios.put(
                `${window._env_.REACT_APP_APIS}/wm/TransactionSubLot/UpdateTotalWeight`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            );
            if (res.data.success) {
                props.setShowPopup(prevFormData => ({ ...prevFormData, visible: false }));
                props.refreshSublotGrid();
                if(res.data.data)
                  props.setSelectedSubLot(res.data.data);
            }
            else {
                alert(res.data.message, "Unable to Generate SubLots");
            }

        } catch (error) {
            console.error("Validation error:", error);
        }
        finally {
            props.setLoadPanelVisible(false);
        }
    }
    return (<>
        {props.showPopup.visible == true ? (
            <Popup
                visible={props.showPopup.visible}
                onHiding={() => props.setShowPopup(prevFormData => ({ ...prevFormData, visible: false }))}
                dragEnabled={false}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title={props.title}
                container="#root"
                width="50vw"
                height="50vh"
            >
                <div className="row">
                    <p>
                        This program allows you to Manually change the Total Net & Gross
                        Weights in the Transaction Sub Detail record. Upon SAVING the
                        transaction Sub Detail record the SUBLOT MASTER record will be
                        updated to reflect the new Average Net & gross weights fields.
                        The average weight is calculated by going through ALL "Receipts,
                        Shipments & Adjustment" transactions for committed and uncommitted
                        records.

                        Please Note that Once the Sub Detail Total Weights are changed, the
                        program will NOT recalculate Total Weights in the Transaction Sub
                        Detail Record when the quantities or any other information is changed.
                        This program ONLY updates the weights in the SUBLOT Master record.
                        The "Weight Source" in the Item Master Record is not used for
                        calculations or updated by this program.
                    </p>

                    {TotalWeightLayout.map((group, groupIndex) => (
                        <fieldset className="list col-md-4 group-col col-fieldset" key={groupIndex}>
                            <legend className="list-title">{group.label}</legend>
                            {group.fields.map((field, idx) => (
                                <div style={{ marginBottom: "1.4rem" }} key={idx + field.name}>
                                    {Fields(field, formFields, handleFieldChange, false, false, formRefs)}
                                </div>
                            ))}
                        </fieldset>
                    ))}

                </div>
                <div className="row">
                    <div className="col-md-12 mt-3">
                        <Button type="default" text="Ok" onClick={UpdateTotalWeight} />
                    </div>
                </div>
            </Popup>) : (null)}
    </>);
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(UpdateSubDetailTotalWeight);
